import { ThemedFunctor } from '@doveit/bricks';
import { css } from 'styled-components';

export const wrapper: ThemedFunctor = () => css`
  min-width: 18rem;
`;

export const address: ThemedFunctor = ({ theme }) => css`
  display: flex;
  gap: ${theme.remSize[75]};

  > *:first-child {
    flex-shrink: 0;
  }

  > *:last-child {
    flex-grow: 1;
  }
`;
